/**
 * BİLDİRİMDEN EKRANA — F-NTF-09
 *
 * Bildirimin `linkUrl` alanı bir YOL taşıyor (`/raporlar/abc123`),
 * ama panel bir yönlendirici (router) kullanmıyor: hangi ekranın
 * açık olduğunu `aktif` durumu tutuyor. Yolu ekrana çevirmek bu
 * dosyanın işi.
 *
 * ================================================================
 * NEDEN AYRI VE SAF BİR MODÜL
 * ================================================================
 * Eşleme JSX'in içinde yazılsaydı test edilemezdi ve yeni bir
 * bildirim türü eklendiğinde kimse bu tabloyu güncellemeyi
 * hatırlamazdı. Burada duruyor, testi var ve tanınmayan yol
 * `null` dönüyor — sessizce yanlış ekrana götürmüyor.
 *
 * ================================================================
 * TANINMAYAN YOL: DÜĞMEYİ HİÇ GÖSTERME
 * ================================================================
 * "Kayda git" düğmesi bugüne kadar `onGit` almadığı için HİÇ
 * çalışmıyordu — basılınca hiçbir şey olmuyordu. Çözüm, her yolu
 * bir yere götürmek değil: götüremediğimiz yolda düğmeyi hiç
 * göstermemek. Basılıp hiçbir şey olmayan bir düğme, olmayan bir
 * düğmeden kötüdür.
 */

/** Panelin ekran anahtarları — `Uygulama.tsx` ile aynı sözlük. */
export interface YonlendirmeHedefi {
  /** `Uygulama.tsx`'teki `aktif` değeri */
  ekran: string;
  /**
   * Ekran bir öğrenci seçimi bekliyorsa onun kimliği.
   *
   * Adı BURADA ÇÖZÜLMÜYOR: bu modül saf ve ağa çıkmıyor. Çağıran
   * taraf kimliği alıp adı kendi listesinden buluyor.
   */
  ogrenciId?: string;
}

/**
 * Eşleme tablosu.
 *
 * Her satır: yolun ilk parçası → hedef ekran. İkinci parça varsa
 * `kimlikNe` onun ne olduğunu söylüyor.
 */
const TABLO: ReadonlyArray<{
  onEk: string;
  ekran: string;
  /** İkinci parça bir öğrenci kimliği mi, yoksa başka bir şey mi. */
  kimlikNe: "ogrenci" | "diger" | "yok";
}> = [
  // Veli raporu — uzman tarafı. İkinci parça RAPOR kimliği.
  { onEk: "raporlar", ekran: "raporlar", kimlikNe: "diger" },
  // Anket YÖNETİMİ (veli anket sayfası değil — o panelin dışında).
  { onEk: "anketler", ekran: "raporlar", kimlikNe: "diger" },
  { onEk: "program", ekran: "program", kimlikNe: "ogrenci" },
  { onEk: "ogrenciler", ekran: "ogrenciler", kimlikNe: "ogrenci" },
  { onEk: "onaylar", ekran: "onay-kuyrugu", kimlikNe: "yok" },
  { onEk: "talepler", ekran: "talepler", kimlikNe: "yok" },
  { onEk: "gorusmeler", ekran: "gorusmeler", kimlikNe: "yok" },
  { onEk: "kocluk", ekran: "kocluk", kimlikNe: "ogrenci" },
  { onEk: "denemeler", ekran: "denemeler", kimlikNe: "ogrenci" },
  { onEk: "finans", ekran: "finans", kimlikNe: "yok" },
  { onEk: "operasyon", ekran: "operasyon", kimlikNe: "yok" },
  { onEk: "takvim", ekran: "takvim", kimlikNe: "yok" },
  { onEk: "yedek", ekran: "yedek", kimlikNe: "yok" },
  { onEk: "loglar", ekran: "loglar", kimlikNe: "yok" },
];

/**
 * `linkUrl`i panel ekranına çevirir.
 *
 * @returns tanınmayan ya da panel dışı bir yol için `null`
 */
export function bildirimHedefi(linkUrl: string | null): YonlendirmeHedefi | null {
  if (linkUrl === null) return null;

  const temiz = linkUrl.trim();
  if (temiz === "") return null;

  /*
    DIŞ BAĞLANTI PANELE ÇEVRİLMİYOR.
    Duyuru bildirimi serbest bir URL taşıyabiliyor
    (`operasyon.controller.ts` `baglanti` alanı `z.string().url()`).
    "https://..." ile başlayan bir yolu ekran anahtarı sanmak,
    kullanıcıyı alakasız bir ekrana götürürdü.
  */
  if (/^[a-z][a-z0-9+.-]*:/i.test(temiz)) return null;
  if (temiz.startsWith("//")) return null;

  const parcalar = temiz.replace(/^\/+/, "").split("/").filter(Boolean);
  if (parcalar.length === 0) return null;

  const satir = TABLO.find((t) => t.onEk === parcalar[0]);
  if (!satir) return null;

  if (satir.kimlikNe === "ogrenci" && parcalar[1]) {
    return { ekran: satir.ekran, ogrenciId: parcalar[1] };
  }

  return { ekran: satir.ekran };
}
